import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { Recebimento, ModalRecebimento, IRequestMessage, RecebimentoItem, ProfissionalExecutante, RecebimentoFiltro, RecebimentoPaciente, NovoProcedimento, RecebimentoItens, ResumoProfissional, DataTablePagination } from '@/types/_'
import Apis from '@/Apis/_'
import moment from 'moment'
import { timeout } from '@/utils/common'
import { cpf } from 'cpf-cnpj-validator'

type FontePagadoraRecebimento = {
  fontePagadoraId: string,
  fontePagadoraNome: string,
}

type RelatorioRecebimento = {
  id: string,
  nome: string,
}

@Module({ namespaced: true, name: 'RecebimentoStore' })
export default class RecebimentoStore extends VuexModule {
  public requestMessage: IRequestMessage = {
    avancar: {
      text: 'Carregando...',
    },
    continuarDepois: {
      text: 'Enviando...',
    },
    init: {
      text: 'Carregando...',
    },
    status: true,
    deleteMessage: 'Deletando...',
    post: 'Enviando...',
    update: 'Atualizando...',
    messageFinish: 'Solicitação enviada com sucesso!',
    errorApi: 'Houve um erro no envio dos dados.',
    errorUpload: '',
    search: 'Buscando...',
  }

  modalRecebimento: ModalRecebimento = {
    detalhes: false,
    filtro: false,
  }

  recebimentoDefault: Recebimento = {
    contratoId: '',
    dataRecebimento: '',
    fontePagadora: '',
    fontePagadoraId: '',
    nomeArquivoOriginal: '',
    grupoRepasseNome: '',
    descontos: [],
    notasFiscais: [],
    documentosAdicionais: [],
    acoes: {
      atualizar: false,
    },
    id: '',
    numeroRepasse: '',
    numeroPedido: '',
    prestador: '',
    previsaoRecebimento: '',
    valorBruto: 0,
    extratoDadosNfObrigatorios: false,
  }

  private paginacaoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 20, 25],
  }

  public recebimento: Recebimento = { ...this.recebimentoDefault }
  public valoresCalculados: any[] = []
  public valorLiquido: string = ''
  public situacaoRecebimento: string = 'AReceber'
  public fontePagadoraSelected: any[] = []
  public anoMesReferenciaSelected: string[] = []
  public dataInicio: string = ''
  public dataFim: string = ''
  public anoMesReferenciaDeSelected: string = ''
  public anoMesReferenciaAteSelected: string = ''
  public modalCadastroEmpresaMedicaResponsavel: boolean = false
  public modalGestores: boolean = false
  public modalAddGestores: boolean = false
  public contratoGestores: any[] = []
  public contratoId: string = ''
  public dadosAddGestor: any = {}
  public gestorIdResponse: string = ''
  public dadosContratoEGestores: any[] = []
  public fontePagadoraIdContrato: string = ''
  public selectedPrestador: any = ''
  public selectedProfissional: any = []
  public tabelaPrecoId: any = ''
  public idTabelaProfissionais: any = ''
  public modalTabelaPrestador: boolean = false
  public modalTabelaProfissionais: boolean = false
  public modalTabelaRegras: boolean = false
  public modalTabelaProfissional: boolean = false
  public modalTabelaOperadora: boolean = false
  public modalAddTabelaPrestador: boolean = false
  public modalAddProfissional: boolean = false
  public modalAddTabelaProfissional: boolean = false
  public modalAddTabelaOperadora: boolean = false
  public tabelaPrestadores: any[] = []
  public profissionais: any[] = []
  public tabelaProfissionais: any[] = []
  public tabelaProfissionaisById: any[] = []
  public operadorasList: any[] = []
  public selectedOperadora: any = ''
  public tabelaOperadoras: any[] = []
  public prestadoresRepasse: any = []
  public prestadores: any = []
  public modalDadosNF: boolean = false
  public nfSelected: any = {}
  public numeroNota: string = ''
  public valorNotaFiscal: number = 0
  public nomeEquipe: string = ''
  public equipeId: any = ''
  public selectedEmpresaMedica: any = ''
  public descricaoEquipe: string = ''
  public filtrarPorProcedimentos: boolean = false
  // `procedimentosEquipes` continua sendo o que vai no payload do salvar.
  // `procedimentosEquipesDetalhe` guarda o rotulo de cada um so para exibir: com a busca
  // no servidor, o item selecionado some da lista de opcoes assim que o termo muda, e sem
  // isso a tela nao teria como mostrar o que ja foi escolhido.
  public procedimentosEquipes: string[] = []
  public procedimentosEquipesDetalhe: { valor: string, rotulo: string }[] = []
  public filtrarPorHospital: boolean = false
  public hospitalEquipe: string = ''
  public deleteId: any = ''
  public paginacaoTabelaPrestadores: DataTablePagination = { ...this.paginacaoDefault }

  recebimentoFiltroDefault: RecebimentoFiltro = {
    pagina: 1,
    contratoId: '',
    prestadorRecebimentoId: '',
    numeroAtendimento: '',
    paciente: '',
    procedimento: '',
    profissionalExecutante: '',
    selecionarPeriodo: 'false',
    dataRealizacaoInicial: '',
    dataRealizacaoFinal: '',
  }

  recebimentoFiltro: RecebimentoFiltro = { ...this.recebimentoFiltroDefault }

  recebimentos: Recebimento[] = []
  recebimentoItens: RecebimentoItens = {
    acoes: {},
    itens: [],
    logoHospital: '',
    valorTotal: 0,
  }

  profissionaisExecutantes: ProfissionalExecutante[] = []
  resumoProfissionais: ResumoProfissional[] = []
  pacientes: RecebimentoPaciente[] = []
  procedimentos: NovoProcedimento[] = []
  procedimentosList: NovoProcedimento[] = []
  hospitaisList: any[] = []
  profissionaisTable: any[] = []
  regrasEquipeMedica: any[] = []
  pagina: number = 1
  paginaEquipes: number = 1
  qtdPorPagina: number = 50
  // Tamanho de página próprio da listagem de equipes: o `qtdPorPagina` acima é
  // compartilhado com outras consultas, e esta tela pagina de 10 em 10.
  qtdPorPaginaEquipes: number = 10
  // Paginação própria do modal de profissionais (não usar `pagina`, que é compartilhado).
  paginaProfissionaisEquipe: number = 1
  qtdPorPaginaProfissionaisEquipe: number = 10
  totalProfissionaisEquipe: number = 0
  searchProfissionalEquipe: string = ''
  searchGerenciamentoEquipe: string = ''
  equipesAllList: any[] = []
  totalEquipesList: number = 0
  totalPagina: number = 0
  recebimentoListItemEmpty: boolean = false
  isEditEquipe: boolean = false
  modalProfissionais: boolean = false
  showAntecipacao: boolean = false

  @Mutation
  setShowAntecipacao(value: boolean) {
    this.showAntecipacao = value
  }

  @Mutation
  setModalTabelaPrestador(value: boolean) {
    this.modalTabelaPrestador = value
  }

  @Mutation
  setModalTabelaProfissionais(value: boolean) {
    this.modalTabelaProfissionais = value
  }

  @Mutation
  setModalTabelaRegras(value: boolean) {
    this.modalTabelaRegras = value
  }

  @Mutation
  setNomeEquipe(value: string) {
    this.nomeEquipe = value
  }

  @Mutation
  setEquipeId(value: any) {
    this.equipeId = value
  }

  @Mutation
  setSelectedEmpresaMedica(value: any) {
    this.selectedEmpresaMedica = value
  }

  @Mutation
  resetEquipeForm() {
    this.nomeEquipe = ''
    this.equipeId = ''
    this.descricaoEquipe = ''
    this.filtrarPorProcedimentos = false
    this.procedimentosEquipes = []
    this.procedimentosEquipesDetalhe = []
    this.filtrarPorHospital = false
    this.hospitalEquipe = ''
  }

  @Mutation
  setDescricaoEquipe(value: string) {
    this.descricaoEquipe = value
  }

  @Mutation
  setFiltrarPorProcedimentos(value: boolean) {
    this.filtrarPorProcedimentos = value
  }

  @Mutation
  setProcedimentosEquipes(value: string[]) {
    this.procedimentosEquipes = value
  }

  @Mutation
  adicionarProcedimentoEquipe(procedimento: { valor: string, rotulo: string }) {
    if (this.procedimentosEquipes.includes(procedimento.valor)) {
      return
    }

    this.procedimentosEquipes = [...this.procedimentosEquipes, procedimento.valor]
    this.procedimentosEquipesDetalhe = [...this.procedimentosEquipesDetalhe, procedimento]
  }

  @Mutation
  removerProcedimentoEquipe(valor: string) {
    this.procedimentosEquipes = this.procedimentosEquipes.filter(v => v !== valor)
    this.procedimentosEquipesDetalhe = this.procedimentosEquipesDetalhe.filter(p => p.valor !== valor)
  }

  @Mutation
  setFiltrarPorHospital(value: boolean) {
    this.filtrarPorHospital = value
  }

  @Mutation
  setHospitalEquipe(value: string) {
    this.hospitalEquipe = value
  }

  @Mutation
  setDeleteId(value: any) {
    this.deleteId = value
  }

  @Mutation
  setModalDadosNF(value: boolean) {
    this.modalDadosNF = value
  }

  @Mutation
  setNFSelected(value: any) {
    this.nfSelected = value
  }

  @Mutation
  setNumeroNota(value: string) {
    this.numeroNota = value
  }

  @Mutation
  setValorNotaFiscal(value: number) {
    this.valorNotaFiscal = value
  }

  @Mutation
  clearModalDadosNF() {
    this.numeroNota = ''
    this.valorNotaFiscal = 0
  }

  @Mutation
  setModalTabelaProfissional(value: boolean) {
    this.modalTabelaProfissional = value
  }

  @Mutation
  setModalTabelaOperadora(value: boolean) {
    this.modalTabelaOperadora = value
  }

  @Mutation
  setDadosContratoEGestores(value: any[]) {
    this.dadosContratoEGestores = value
  }

  @Mutation
  setFontePagadoraIdContrato(value: string) {
    this.fontePagadoraIdContrato = value
  }

  @Mutation
  setModalAddTabelaPrestador(value: boolean) {
    this.modalAddTabelaPrestador = value
  }

  @Mutation
  setModalAddProfissional(value: boolean) {
    this.modalAddProfissional = value
  }

  @Mutation
  setModalAddTabelaProfissional(value: boolean) {
    this.modalAddTabelaProfissional = value
  }

  @Mutation
  setModalAddTabelaOperadora(value: boolean) {
    this.modalAddTabelaOperadora = value
  }

  @Mutation
  setTabelaPrestadores(value: any) {
    this.tabelaPrestadores = value
  }

  @Mutation
  setTabelaProfissionais(value: any) {
    this.tabelaProfissionais = value
  }

  @Mutation
  setTabelaProfissionaisById(value: any) {
    this.tabelaProfissionaisById = value
  }

  @Mutation
  setProfissionais(value: any) {
    this.profissionais = value
  }

  @Mutation
  setTabelaOperadoras(value: any) {
    this.tabelaOperadoras = value
  }

  @Mutation
  setPrestadoresRepasse(value: any[]) {
    this.prestadoresRepasse = value
  }

  @Mutation
  setPrestadores(value: any[]) {
    this.prestadores = value
  }

  @Mutation
  setSelectedPrestador(value: any) {
    this.selectedPrestador = value
  }

  @Mutation
  setSelectedProfissional(value: any) {
    this.selectedProfissional = value
  }

  @Mutation
  setTabelaPrecoId(value: any) {
    this.tabelaPrecoId = value
  }

  @Mutation
  setIdForLoadTabelaProfissionaisById(value: any) {
    this.idTabelaProfissionais = value
  }

  @Mutation
  setAnoMesReferenciaDeSelected(value: string) {
    this.anoMesReferenciaDeSelected = value
  }

  @Mutation
  setGestorIdResponse(value: string) {
    this.gestorIdResponse = value
  }

  @Mutation
  setDadosAddGestor(value: any) {
    this.dadosAddGestor = value
  }

  @Mutation
  setContratoId(value: string) {
    this.contratoId = value
  }

  @Mutation
  setModalCadastroEmpresaMedicaResponsavel(value: boolean) {
    this.modalCadastroEmpresaMedicaResponsavel = value
  }

  @Mutation
  setModalGestores(value: boolean) {
    this.modalGestores = value
  }

  @Mutation
  setModalAddGestores(value: boolean) {
    this.modalAddGestores = value
  }

  @Mutation
  setContratoGestores(value: any) {
    this.contratoGestores = value
  }

  @Mutation
  setAnoMesReferenciaAteSelected(value: string) {
    this.anoMesReferenciaAteSelected = value
  }

  fontePagadora: FontePagadoraRecebimento = { fontePagadoraId: '', fontePagadoraNome: '' }
  fontePagadoras: any[] = []
  relatorioEmissaoId: string = ''
  relatorioEmitido: any = {}
  fontesPagadoras: FontePagadoraRecebimento[] = []
  relatorio: RelatorioRecebimento = { id: '', nome: '' }
  relatorios: RelatorioRecebimento[] = []
  podeEmitirRelatorio: boolean = false
  anoMesReferencia: string = ''
  documentoProfissional: string = ''

  @Mutation
  setFontePagadora(value: FontePagadoraRecebimento) {
    this.fontePagadora = value
  }

  @Mutation
  setRelatorioEmissaoId(value: string) {
    this.relatorioEmissaoId = value
  }

  @Mutation
  setRelatorioEmitido(value: any) {
    this.relatorioEmitido = value
  }

  @Mutation
  setFontePagadoras(data: any) {
    this.fontePagadoras = data
  }

  @Mutation
  setFontePagadoraSelected(value: any[]) {
    if (this.fontePagadoraSelected.includes(value)) {
      this.fontePagadoraSelected.splice(this.fontePagadoraSelected.indexOf(value), 1)
    } else {
      this.fontePagadoraSelected.push(value)
    }
  }

  @Mutation
  setAnoMesReferenciaSelected(value: string[]) {
    this.anoMesReferenciaSelected = value

    if (this.anoMesReferenciaSelected.length === 2) {
      const [dataInicio, dataFim] = this.anoMesReferenciaSelected

      this.dataInicio = dataInicio
      this.dataFim = dataFim
    } else {
      console.error('Array de datas deve conter exatamente duas datas.')
    }
  }

  @Mutation
  clearFiltroRecebimento() {
    this.fontePagadoraSelected = []
    this.anoMesReferenciaAteSelected = ''
    this.anoMesReferenciaDeSelected = ''
  }

  @Mutation
  setPodeEmitirRelatorio(value: boolean) {
    this.podeEmitirRelatorio = value
  }

  @Mutation
  setDocumentoProfissional(value: string) {
    this.documentoProfissional = value
  }

  @Mutation
  clearFontePagadora() {
    this.fontePagadora = { fontePagadoraId: '', fontePagadoraNome: '' }
  }

  @Mutation
  setFontesPagadoras(value: FontePagadoraRecebimento[]) {
    this.fontesPagadoras = value
  }

  @Mutation
  clearFontesPagadoras() {
    this.fontesPagadoras = []
  }

  @Mutation
  setRelatorio(value: RelatorioRecebimento) {
    this.relatorio = value
  }

  @Mutation
  clearRelatorio() {
    this.relatorio = { id: '', nome: '' }
  }

  @Mutation
  setRelatorios(value: RelatorioRecebimento[]) {
    this.relatorios = value
  }

  @Mutation
  clearRelatorios() {
    this.relatorios = []
  }

  @Mutation
  setAnoMesReferencia(value: string) {
    this.anoMesReferencia = value
  }

  @Mutation
  clearAnoMesReferencia() {
    this.anoMesReferencia = moment().format('YYYY-MM-01')
  }

  @Mutation
  setRecebimentos(recebimentos: Recebimento[]) {
    this.recebimentos = recebimentos
  }

  @Mutation
  clearDocumento() {
    this.recebimento.nomeArquivoOriginal = ''
  }

  @Mutation
  setNomeArquivoOriginal(nome: string) {
    this.recebimento.nomeArquivoOriginal = nome
  }

  @Mutation
  setModalRecebimentoDetalhes(value: boolean) {
    this.modalRecebimento.detalhes = value
  }

  @Mutation
  setModalRecebimentoFiltro(value: boolean) {
    this.modalRecebimento.filtro = value
  }

  @Mutation
  setNumeroAtendimentoFiltro(value: string) {
    this.recebimentoFiltro.numeroAtendimento = value
  }

  @Mutation
  setRecebimento(value: Recebimento) {
    this.recebimento = value
  }

  @Mutation
  setValoresCalculados(value: any[]) {
    this.valoresCalculados = value
  }

  @Mutation
  setValorLiquido(value: any) {
    this.valorLiquido = value
  }

  @Mutation
  setRecebimentoItens(value: RecebimentoItens) {
    this.recebimentoItens.acoes = value.acoes
    this.recebimentoItens.valorTotal = value.valorTotal
    this.recebimentoItens.logoHospital = value.logoHospital || ''
    value.itens.map(i => this.recebimentoItens.itens.push(i))
    this.recebimentoListItemEmpty = this.recebimentoItens.itens.length === 0
  }

  @Mutation
  setRecebimentoListItemEmpty(value: boolean) {
    this.recebimentoListItemEmpty = value
  }

  @Mutation
  setProfissionaisExecutantes(value: ProfissionalExecutante[]) {
    this.profissionaisExecutantes = value
  }

  @Mutation
  setResumoProfissionais(value: ResumoProfissional[]) {
    this.resumoProfissionais = value
  }

  @Mutation
  setPacientes(value: RecebimentoPaciente[]) {
    this.pacientes = value
  }

  @Mutation
  setProcedimentos(value: NovoProcedimento[]) {
    this.procedimentos = value
    this.procedimentos.map((p) => {
      const item = p
      item.descricaoCompleta = `${item.codigo} - ${item.descricao}`
      return item
    })
  }

  @Mutation
  setProcedimentosList(value: any[]) {
    this.procedimentosList = value
    this.procedimentosList.map((p) => {
      const item = p
      item.descricaoCompleta = `${item.codigo} - ${item.descricao}`
      return item
    })
  }

  @Mutation
  setProfissionaisEquipeMedica(value: any[]) {
    this.profissionaisTable = value
  }

  @Mutation
  setRegrasEquipeMedica(value: any[]) {
    this.regrasEquipeMedica = value
  }

  @Mutation
  setHospitaisList(value: any[]) {
    this.hospitaisList = value
  }

  @Mutation
  setIsEditEquipe(value: boolean) {
    this.isEditEquipe = value
  }

  @Mutation
  setModalProfissionais(value: boolean) {
    this.modalProfissionais = value
  }

  @Mutation
  setEquipeEdit(value: any) {
    this.equipeId = value.id
    this.nomeEquipe = value.nome
    this.filtrarPorHospital = value.filtraHospital
    this.hospitalEquipe = value.hospitalId
    this.filtrarPorProcedimentos = value.filtraProcedimento

    if (value.procedimentos && Array.isArray(value.procedimentos)) {
      this.procedimentosEquipes = value.procedimentos.map(p => p.codigoProcedimento)
      // codigoProcedimentoNome vem do join com Recebimento.Procedimento e volta nulo
      // quando o valor gravado nao casa com nenhum codigo (ver "Fora de escopo" da
      // FXSR-2851). Nesse caso mostramos o valor cru, que é melhor que uma linha vazia.
      this.procedimentosEquipesDetalhe = value.procedimentos.map(p => ({
        valor: p.codigoProcedimento,
        rotulo: p.codigoProcedimentoNome || p.codigoProcedimento,
      }))
    } else {
      this.procedimentosEquipes = []
      this.procedimentosEquipesDetalhe = []
    }
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setPaginaEquipes(value: number) {
    this.paginaEquipes = value
  }

  @Mutation
  setPaginaProfissionaisEquipe(value: number) {
    this.paginaProfissionaisEquipe = value
  }

  @Mutation
  setTotalProfissionaisEquipe(value: number) {
    this.totalProfissionaisEquipe = value
  }

  @Mutation
  setSearchProfissionalEquipe(value: string) {
    this.searchProfissionalEquipe = value
  }

  @Mutation
  resetPaginacaoProfissionaisEquipe() {
    this.paginaProfissionaisEquipe = 1
    this.totalProfissionaisEquipe = 0
    this.searchProfissionalEquipe = ''
  }

  @Mutation
  setSearchGerenciamentoEquipe(value: string) {
    this.searchGerenciamentoEquipe = value
  }

  @Mutation
  setEquipesAll(value: any[]) {
    this.equipesAllList = value
  }

  @Mutation
  setTotalEquipesList(value: number) {
    this.totalEquipesList = value
  }

  @Mutation
  setTotalPagina(value: number) {
    this.totalPagina = value
  }

  @Mutation
  setPeriodoInicio(inicio: string) {
    this.recebimentoFiltro.dataRealizacaoInicial = inicio
  }

  @Mutation
  setPeriodoFinal(final: string) {
    this.recebimentoFiltro.dataRealizacaoFinal = final
  }

  @Mutation
  setOperadoras(value: any) {
    this.operadorasList = value
  }

  @Mutation
  setSelectedOperadora(value: any) {
    this.selectedOperadora = value
  }

  @Mutation
  setCloseDisplay(recebimentoItem: RecebimentoItem) {
    for (let i = 0; i < this.recebimentoItens.itens.length; i++) {
      const element = this.recebimentoItens[i]
      if (element.paciente === recebimentoItem.paciente) {
        element.display = true
      } else {
        element.display = false
      }
    }
  }

  @Mutation
  clearRecebimento() {
    this.pagina = 1
    this.totalPagina = 0
    this.recebimento = { ...this.recebimentoDefault }
    this.recebimentoFiltro = { ...this.recebimentoFiltroDefault }
    this.procedimentos = []
    this.profissionaisExecutantes = []
    this.resumoProfissionais = []
    this.recebimentoItens.itens = []
    this.recebimentoItens.valorTotal = 0
  }

  @Mutation
  clearRecebimentoItens() {
    this.pagina = 1
    this.totalPagina = 0
    this.recebimentoItens.itens = []
    this.recebimentoItens.valorTotal = 0
  }

  @Mutation
  clearFilter() {
    this.recebimentoFiltro = { ...this.recebimentoFiltroDefault }
  }

  @Mutation
  setSituacaoRecebimento(value: string) {
    this.situacaoRecebimento = value
  }

  @Mutation
  clearExportarRegistros() {
    this.fontePagadora = { fontePagadoraId: '', fontePagadoraNome: '' }
    this.relatorio = { id: '', nome: '' }
    this.anoMesReferencia = ''
  }

  @Action
  async getFontePagadoraAll() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getFontePagadoraAll()
      if (request.success) {
        this.context.commit('setFontesPagadoras', request.data as FontePagadoraRecebimento || [])
        this.context.commit('setFontePagadoras', request.data as FontePagadoraRecebimento || [])
      }
      return request
    } catch (error) {
      this.context.commit('setFontesPagadoras', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getDadosContratoEGestores() {
    try {
      const request = await Apis.Legacy.RecebimentoApi.getDadosContratoEGestores()
      if (request.success) {
        this.context.commit('setDadosContratoEGestores', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRelatoriosByFontePagadora() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatoriosByFontePagadora({ area: 'ExtratoPagamento' })
      if (request.success) this.context.commit('setRelatorios', request.data.itens as RelatorioRecebimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setRelatorios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async generateRelatorioByFontePagadora() {
    try {
      const params: any = {
        tipo: 'GeracaoRelatorio',
        atributos: [
          {
            nome: 'fontePagadoraId',
            valor: this.fontePagadora.fontePagadoraId,
          },
          {
            nome: 'relatorioId',
            valor: this.relatorio.id,
          },
          {
            nome: 'anoMesReferencia',
            valor: this.anoMesReferencia,
          },
        ],
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.enfileirar(params)
      this.context.commit('setRelatorioEmissaoId', response.data.id)
      return await this.context.dispatch('getRelatorioEmitido')
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getRelatorioEmitido() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          relatorioEmissaoId: this.relatorioEmissaoId,
        }

        /* eslint-disable no-await-in-loop */
        const statusResponse = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatorioStatus(params)

        if (statusResponse.data.emProcessamento === false) {
          /* eslint-disable no-await-in-loop */
          const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatorioEmitido(params)
          if (response.data.ArquivoUrl) {
            const file = response.data.ArquivoUrl
            const fileName = response.data.NomeArquivo

            this.context.commit('setRelatorioEmitido', {
              file,
              fileName
            })
            return response
          }

          // NÃO REMOVER - PARA DEBUG DO HOSPITAL
          console.log('Erro: o arquivo deveria estar disponível, mas a URL está vazia.')
          return { success: false }
        }

        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  delay(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  @Action
  async getTabelaPrestadores(id: number) {
    try {
      const params: any = {
        tabelaPrecoId: id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaPrestadores(params)
      if (response.success) {
        return this.context.commit('setTabelaPrestadores', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaProfissionais() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaProfissionais()
      if (request.success) {
        this.context.commit('setTabelaProfissionais', request.data.itens)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaProfissionaisById() {
    try {
      const params: any = {
        tabelaPrecoId: this.idTabelaProfissionais
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaProfissionaisById(params)
      if (response.success) {
        this.context.commit('setTabelaProfissionaisById', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getProfissionais(nomeProfissional?: string) {
    try {
      const params = {
        nome: nomeProfissional,
      }

      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionais(params)
      if (request.success) {
        this.context.commit('setProfissionais', request.data.pessoas)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async upsertTabelaProfissional() {
    try {
      const params: any = {
        tabelaPrecoId: this.tabelaPrecoId,
        profissionalId: this.selectedProfissional,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postTabelaProfissional(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaProfissional(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaProfissional(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaOperadora(id: number) {
    try {
      const params: any = {
        tabelaPrecoId: id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTabelaOperadora(params)
      if (response.success) {
        return this.context.commit('setTabelaOperadoras', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getPrestadoresRepasse() {
    try {
      const request = await Apis.Contrato.ContratoApi.getAllPrestadoresByHospital()
      this.context.commit('setPrestadoresRepasse', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setPrestadoresRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPrestadores(params) {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getPrestadores(params)
      if (request.success) {
        this.context.commit('setPrestadores', request.data.prestadores)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async upsertTabelaPrestadores() {
    try {
      const params: any = {
        tabelaPrecoId: this.tabelaPrecoId,
        prestadorId: this.selectedPrestador,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.upsertTabelaPrestadores(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async upsertTabelaProfissionaisById() {
    try {
      const selectedProfissionalIds = this.selectedProfissional.map((profissional: any) => profissional.userId)

      const params: any = {
        equipemedicaId: this.equipeId,
        empresaMedicaId: this.selectedEmpresaMedica || null,
        profissionalId: selectedProfissionalIds,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postEquipeMedicaProfissional(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async postTabelaOperadora() {
    try {
      const params: any = {
        operadoraId: this.selectedOperadora,
        tabelaPrecoId: this.tabelaPrecoId,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.postTabelaOperadora(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getOperadoras() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getConvenio()
      if (request.success) {
        this.context.commit('setOperadoras', request.data.convenios)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaPrestador(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaPrestador(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaProfissionais(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaProfissionais(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteTabelaOperadora(id: any) {
    try {
      const param: any = {
        id,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteTabelaOperadora(param)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async removeContratoGestor(id: string) {
    try {
      const params: any = {
        contratoId: this.contratoId,
        gestorId: id,
      }
      const response = await Apis.Contrato.ContratoApi.removeContratoGestor(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async checkCpfGestor() {
    try {
      const request = await Apis.Cadastro.CadastroApi.checkCpfRemuneracao(this.dadosAddGestor.cpf)
      if (request.success) this.context.commit('setGestorIdResponse', request.data.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - CHECK_CPF_REMUNERACAO' }
    }
  }

  @Action
  async fluxoSemCpf() {
    const params: any = {
      nome: this.dadosAddGestor.nome,
      email: this.dadosAddGestor.email,
      cpf: this.dadosAddGestor.cpf,
    }

    try {
      const response = await Apis.Cadastro.CadastroApi.upsertPessoaRemuneracao(params)
      if (response.success) this.context.commit('setGestorIdResponse', response.data)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - UPSERT_PESSOA_REMUNERACAO' }
    }
  }

  @Action
  async addGestor() {
    const params: any = [this.gestorIdResponse]
    try {
      const response = await Apis.Contrato.ContratoApi.addGestor(this.contratoId, params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - ADD_GESTOR' }
    }
  }

  @Action
  async envioAutenticacao() {
    const params: any = {
      id: this.gestorIdResponse,
      email: this.dadosAddGestor.email,
      name: this.dadosAddGestor.nome,
      hospitalId: this.fontePagadoraIdContrato,
      perfil: 'ExtratoPagamento',
    }
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarUsuario(params)
      if (response.success) this.setModalGestores(false); this.setModalAddGestores(false)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição. - ENVIO_AUTENTICACAO' }
    }
  }

  @Action
  async download(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.download(params)
    return response
  }

  @Action
  async deletarDocumentoPrestadorRecebimento(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumentoPrestadorRecebimento(params)
    return response
  }

  @Action
  async deletarDocumento(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumento(params)
    return response
  }

  @Action
  async deletarDocumentoAdicional(params: any) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deletarDocumentoAdicional(params)
    return response
  }

  @Action
  async uploadNotaFiscal(params: any) {
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.uploadNotaFiscal(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action({ commit: 'setRecebimentos' })
  async loadRecebimentos() {
    const params: any = {
      situacao: this.situacaoRecebimento,
      fontePagadoraIds: this.fontePagadoraSelected,
      dataFim: this.anoMesReferenciaAteSelected ? `${this.anoMesReferenciaAteSelected}-01` : '',
      dataInicio: this.anoMesReferenciaDeSelected ? `${this.anoMesReferenciaDeSelected}-01` : '',
    }
    const request = await Apis.Legacy.RecebimentoApi.loadRecebimentos(params)
    if (request.success) {
      const data = Array.isArray(request.data) ? request.data : []

      if (data.length > 0) {
        this.context.commit('setDocumentoProfissional', data[0].cnpjPrestador)
      }
      return data
    }

    return []
  }

  @Action
  async recebimentoAcoes() {
    try {
      const response = await Apis.Legacy.RecebimentoApi.recebimentoAcoes()
      if (response.success) {
        this.context.commit('setPodeEmitirRelatorio', response.data.acoes.AppExibirGerarRelatorioRepasses)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action({ commit: 'setRecebimentoItens' })
  async loadRecebimentoItens() {
    this.context.commit('setRecebimentoListItemEmpty', false)
    const filtro = this.recebimentoFiltro
    filtro.pagina = this.pagina
    filtro.contratoId = this.recebimento.contratoId
    filtro.prestadorRecebimentoId = this.recebimento.id

    const request = await Apis.Legacy.RecebimentoApi.loadRecebimentoItens(filtro)

    return request.success ? request.data : []
  }

  @Action({ commit: 'setProfissionaisExecutantes' })
  async loadProfissionaisExecutantes() {
    const prestadorRecebimentoId = this.recebimento.id
    const { contratoId } = this.recebimento

    const request = await Apis.Legacy
      .RecebimentoApi.loadProfissionaisExecutantes(prestadorRecebimentoId, contratoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setResumoProfissionais' })
  async loadResumoProfissionais() {
    const filtro = { ...this.recebimentoFiltro }
    filtro.contratoId = this.recebimento.contratoId
    filtro.prestadorRecebimentoId = this.recebimento.id

    const request = await Apis.Legacy.RecebimentoApi.loadResumoProfissionais(filtro)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setPacientes' })
  async loadPacientes() {
    const prestadorRecebimentoId = this.recebimento.id
    const { contratoId } = this.recebimento

    const request = await Apis.Legacy
      .RecebimentoApi.loadPacientes(prestadorRecebimentoId, contratoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setProcedimentos' })
  async loadProcedimentos() {
    const prestadorRecebimentoId = this.recebimento.id
    const { contratoId } = this.recebimento

    const request = await Apis.Legacy
      .RecebimentoApi.loadProcedimentos(prestadorRecebimentoId, contratoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action
  async exportarExcel() {
    const prestadorRecebimentoId = this.recebimento.id

    const request = await Apis.Legacy
      .RecebimentoApi.exportarExcel(prestadorRecebimentoId)
    return request
  }

  @Action
  async getValoresCalculados(id: string) {
    try {
      const request = await Apis.Legacy.RecebimentoApi.getValoresCalculados(id)
      this.context.commit('setValoresCalculados', request.data.itens)
      this.context.commit('setValorLiquido', request.data.valorLiquido)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getFontePagadoraLoggedUser() {
    const response = await Apis.Legacy.RecebimentoApi.getFontePagadoraLoggedUser()
    if (response.success) {
      this.context.commit('setFontePagadoras', response.data)
    }

    return response
  }

  @Action
  async getRelatoriosByFontePagadoraBackoffice() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRelatoriosByFontePagadora({ area: 'Financeiro' })
      if (request.success) this.context.commit('setRelatorios', request.data.itens as RelatorioRecebimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setRelatorios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getEquipesAll() {
    try {
      const params: any = {
        nome: this.searchGerenciamentoEquipe,
        pagina: this.paginaEquipes,
        qtdPorPagina: this.qtdPorPaginaEquipes,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getEquipesAll(params)
      if (request.success) {
        this.context.commit('setEquipesAll', request.data.itens)
        this.context.commit('setTotalEquipesList', request.data.totalRegistros)
        return request.data
      }
      return []
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProcedimentosList(filtro?: string) {
    try {
      // Sem filtro sao ~7 mil procedimentos por grupo hospitalar; a busca vai para o
      // servidor (o endpoint aceita ?filtro= por codigo e descricao).
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProcedimentosEquipeMedica(filtro)
      if (request.success) {
        this.context.commit('setProcedimentosList', request.data.procedimentos)
      }
      return request
    } catch (error) {
      this.context.commit('setProcedimentosList', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getProfissionaisEquipeMedica(nome?: string) {
    try {
      // Busca nova (veio termo) recomeça da primeira página; navegação de página
      // chama sem argumento e preserva o filtro corrente.
      if (nome !== undefined) {
        this.context.commit('setSearchProfissionalEquipe', nome || '')
        this.context.commit('setPaginaProfissionaisEquipe', 1)
      }

      const params: any = {
        id: this.equipeId,
        pagina: this.paginaProfissionaisEquipe,
        profissionalNome: this.searchProfissionalEquipe,
        qtdPorPagina: this.qtdPorPaginaProfissionaisEquipe,
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getProfissionaisEquipeMedica(params)
      if (request.success) {
        this.context.commit('setProfissionaisEquipeMedica', request.data.itens)
        this.context.commit('setTotalProfissionaisEquipe', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setProfissionaisEquipeMedica', [])
      this.context.commit('setTotalProfissionaisEquipe', 0)
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getRegrasEquipeMedica() {
    try {
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getRegrasEquipeMedica({
        equipeProfissionalId: this.equipeId,
      })
      if (request.success) {
        this.context.commit('setRegrasEquipeMedica', request.data.itens)
      }
      return request
    } catch (error) {
      this.context.commit('setRegrasEquipeMedica', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async salvarEquipe() {
    try {
      let params: any = {}
      if (this.isEditEquipe) {
        params = {
          id: this.equipeId,
          nome: this.nomeEquipe,
          filtraHospital: this.filtrarPorHospital,
          hospitalId: this.filtrarPorHospital ? this.hospitalEquipe : null,
          filtraProcedimento: this.filtrarPorProcedimentos,
          procedimentos: this.filtrarPorProcedimentos ? this.procedimentosEquipes : [],
        }
      } else {
        params = {
          nome: this.nomeEquipe,
          filtraHospital: this.filtrarPorHospital,
          hospitalId: this.filtrarPorHospital ? this.hospitalEquipe : null,
          filtraProcedimento: this.filtrarPorProcedimentos,
          procedimentos: this.filtrarPorProcedimentos ? this.procedimentosEquipes : [],
        }
      }
      const request = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarEquipe(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteEquipeMedica() {
    try {
      const params: any = {
        id: this.deleteId,
      }
      return await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteEquipeMedica(params)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
